import { translate } from '@td/shared_utils';

export const newPatientStatusLabel = (translationKey, { providerExtension, licenses }) => {
  const hasLicenses = Array.isArray(licenses) && licenses.length > 0;

  if (!hasLicenses && providerExtension && !providerExtension.acceptingNewPatients) {
    const key = providerExtension.updatedByAdmin ?
      'off_by_admin_no_licenses' :
      'off_by_provider_no_licenses';

    return translate(null, translationKey, key);
  }

  if (!providerExtension) {
    return null;
  }

  if (!hasLicenses) {
    return translate(null, translationKey, 'no_licenses');
  }

  if (providerExtension.acceptingNewPatients) {
    return translate(null, translationKey, 'on');
  }

  const key = providerExtension.updatedByAdmin ? 'off_by_admin' : 'off_by_provider';
  return translate(null, translationKey, key);
};
